<div class="flex flex-column gap-2 p-1 m-1">
  <p-confirmDialog
    header="Confirmation"
    icon="fas fa-exclamation-triangle"
    rejectIcon="fas fa-times p-button-warning"
    rejectButtonStyleClass="p-button-danger"
    acceptIcon="fas fa-check"
    acceptButtonStyleClass="p-button-success"
    ></p-confirmDialog>
  <div class="flex flex-row flex-wrap">
    <div class="flex flex-1">
      <p-select [options]="fileOptions" [(ngModel)]="file" placeholder="Select a file"></p-select>
    </div>
    <p-button-group class="flex flex-none">
      <button pButton type="button" label="Import" (click)="importChebi()" [disabled]="!file"></button>
      <button pButton type="button" label="Reindex" icon="fa fa-solid fa-arrows-rotate" severity="secondary" (click)="reindexChebi()"></button>
    </p-button-group>
  </div>
  <app-crud-table [title]="'ChEBI Entries'" [columns]="columns" [filterFields]="filterFields" [crudAdapter]="crudAdapter"></app-crud-table>
</div>
